import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { post } from './cmsAxios';

const uploadMultiToFolder = async (
  folder: string,
  files: any[],
  userId: number,
): Promise<any> => {
  const data: any = new FormData();
  data.append('folder', folder);
  const filenames: any[] = files.map((f) => f.name);
  const map = files.reduce((result, x) => {
    result[x.name] = x;
    return result;
  }, {});
  data.append('files', filenames);

  const { data: presignedUrls } = await post('/presigned-url', data);
  const uploadedFiles = await Promise.all(
    Object.keys(presignedUrls).map(async (name) => {
      const { key, url, code } = presignedUrls[name];
      const file = map[name];
      const options = { headers: { 'Content-Type': file.type } };
      await axios.put(url, file, options);
      return { key, name, code };
    }),
  );

  return post('/presigned-url/ack', {
    folder,
    userId,
    files: uploadedFiles,
  });
};

export const uploadFilesToCms = (
  objectId: number | null,
  files: any[],
  name: string,
  userId: number,
  folderPath: string,
) => {
  let filesList = files.filter((f) => f.id);

  const newFiles = files.filter((f) => !f.id);
  if (newFiles && newFiles.length === 0) {
    return Promise.resolve({ name: name, filesList });
  }
  console.log('Files will be uploaded to CMS', newFiles);

  const idFolder = objectId ? `${folderPath}/${objectId}` : `${folderPath}/temp/${uuidv4()}`;

  return uploadMultiToFolder(idFolder, newFiles, userId)
    .then((res) => {
      const { data } = res;
      const uploadedFiles = Object.values(data.photoIds);

      const savedPhotos =
        files.filter((f) => f.id && uploadedFiles.findIndex((p: any) => p.id === f.id) < 0) || [];

      filesList = uploadedFiles.concat(savedPhotos);
      return { name: name, filesList };
    })
    .catch((err) => {
      console.error(err);
      return { name: name, filesList };
    });
};
